import { useState, useEffect, memo } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import classes from "./ConfirmStatusChangeModal.module.scss";
import DialogButton from "../DialogButton";
import { ta } from "date-fns/locale";
import {
  ORDER_CANCELLED,
  ORDER_CONFIRMED,
  ORDER_PLACED,
  ORDER_RECEIVED,
  SELECTED_ORDER_PLACED,
} from "../../../constants/orderStatus";
import ColorButtons from "../ColorButtons";

const style = {
  box: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: 320, // 0px以上の幅で360pxを適用
      sm: 360, // 600px以上の幅で400pxを適用
    },
    //width: 300,
    bgcolor: "background.paper",
    border: "none",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "20px 0",
  },

  iconImage: {
    color: "error.main",
    marginTop: 0.5,
  },
  title: {
    color: "error.main",
  },
  message: {
    marginTop: "20px",
    marginLeft: "20px",
    marginBottom: "20px",
  },
};
// 再発行(注文書PDFの再作成)の可否。ステータス遷移の可否とは別ルールなので
// functions/order/statusTransition.js には統合していない(全件が発注済であること)。
const canReIssue = (targetStatus, orders) => {
  let isUpdatable = false;

  let unUpdatables = [];

  //発注ボタンが押された場合
  if (targetStatus === ORDER_CONFIRMED) {
    isUpdatable = orders.every((order) => order.status === ORDER_CONFIRMED);
    unUpdatables = orders.filter((order) => order.status !== ORDER_CONFIRMED);
  }

  return { isUpdatable, unUpdatables };
};
export const ConfirmCreatePdfModal = memo((props) => {
  const { targetStatus, setIsShow, onExec, onCancel, orders } = props;
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setIsShow(false);
    setOpen(false);
  };
  const { isUpdatable, unUpdatables } = canReIssue(targetStatus, orders);
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style.box} onClick={handleClose}>
          <div className={classes.root}>
            {isUpdatable ? (
              <div className={classes.container}>
                <div className={`${classes.title} ${classes.confirm}`}>
                  <ErrorOutlineIcon className={classes.iconImage} />
                  {`${orders.length}件の注文を`}
                  <p
                    className={`${classes.status} ${
                      targetStatus === ORDER_PLACED
                        ? classes.placed
                        : targetStatus === ORDER_CONFIRMED
                        ? classes.confirmed
                        : targetStatus === ORDER_RECEIVED
                        ? classes.received
                        : classes.canceled
                    }`}
                  >
                    {"再発行"}
                  </p>
                  します
                </div>
                <div className={classes.spacer}></div>
                <div className={classes.message}>{"よろしいですか？"}</div>
                <div className={classes.buttons}>
                  <ColorButtons
                    label={"はい"}
                    color="placed"
                    onClick={() => onExec(orders)}
                    width={90}
                    height={32}
                    bottom={0}
                  />
                  <ColorButtons
                    label={"いいえ"}
                    color="grey"
                    onClick={onCancel}
                    width={90}
                    height={32}
                    bottom={0}
                  />
                </div>
              </div>
            ) : (
              <div className={classes.container}>
                <div className={`${classes.title} ${classes.alert}`}>
                  <ErrorOutlineIcon className={classes.iconImage} />
                  {`実行できない発注が${unUpdatables.length}件含まれています`}
                </div>
                <div className={classes.message}>{"発注番号"}</div>
                <div className={classes.orderNos}>
                  {unUpdatables.map((order) => (
                    <div
                      key={order.id}
                      className={`${classes.orderNo} ${
                        order.status === ORDER_PLACED
                          ? classes.placed
                          : order.status === ORDER_CONFIRMED
                          ? classes.confirmed
                          : order.status === ORDER_RECEIVED
                          ? classes.received
                          : classes.canceled
                      }`}
                    >
                      {order.order_number}
                    </div>
                  ))}
                </div>
                <ColorButtons
                  label={"閉じる"}
                  color="grey"
                  onClick={onCancel}
                  width={90}
                  height={32}
                  bottom={0}
                />
              </div>
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
});
